import { EnvironmentSelectorState } from '../../../../common/environment/reducer'
import { ResourceSelectorState } from '../../../../common/resource/reducer'
import { ARMHybridDetail, ARMServer, User } from '../../../../remote-api/models'
import { VersionSelectorState } from '../../../../common/version/reducer'
import { BasicAlert } from '../../model'
import { ResourceType } from '@mulesoft/monitoring-center-components/lib/models/resource'
import { BasicSelectorOption } from '@mulesoft/monitoring-center-components/lib/components/Selector/BasicSelector/BasicSelector'
import { APIPolicySelectorState } from '../../../../common/policies/reducer'

export const alertsOrigin = 'alerts'

export type BasicAlertModalState = {
  isBasicAlertModalOpened: boolean
  apiResponseCodesLimit: number
  existingAlert?: BasicAlert
  serversLoading: boolean
  servers: ARMServer[]
  environmentSelector: EnvironmentSelectorState
  resourceSelector: ResourceSelectorState
  versionSelector: VersionSelectorState
  serverApplications?: ARMHybridDetail[]
  policySelector: APIPolicySelectorState
  users: User[]
}

export const getBasicAlertsResourceType = (resourceId: string, versionId?: string, targetId?: string) => {
  if (versionId) return ResourceType.API
  if (resourceId.includes('.')) return ResourceType.CLOUDHUB_APPLICATION
  if (targetId && !isNaN(+targetId)) return ResourceType.HYBRID_APPLICATION
  return ResourceType.RTF_APPLICATION
}

export const getUserEmailOption = (user: User): BasicSelectorOption => {
  return {label: `${user.firstName} ${user.lastName} (${user.email})`, value: user.email}
}

export const getSelectedRecipients = (users: User[], emails: string[]): BasicSelectorOption[] => {
  return emails.map(email => {
    const userFromEmail = users.find(user => user.email === email)
    return userFromEmail ? getUserEmailOption(userFromEmail) : {value: email, label: email}
  })
}
